import { Block, PronunciationEffect } from '../contexts/TtsContext';

const generateBlockSsml = (block: Block) => {
  const { id, controls } = block;
  const { speaker, speed, pitch, volume, style } = controls;

  const blockVoice = document.createElement('voice');
  blockVoice.setAttribute('id', id);
  blockVoice.setAttribute('name', speaker.text);

  let styleBlock;

  if (style) {
    styleBlock = document.createElement('mstts:express-as');
    styleBlock.setAttribute('style', style);
  }

  const blockProsody = document.createElement('prosody');
  blockProsody.setAttribute('rate', speed);
  blockProsody.setAttribute('pitch', pitch);
  blockProsody.setAttribute('volume', volume);

  const content = applySelections(block);

  if (styleBlock) {
    styleBlock.innerHTML = content;
    blockProsody.appendChild(styleBlock);
  } else {
    blockProsody.innerHTML = content;
  }

  blockVoice.appendChild(blockProsody);

  if (block.controls.break) {
    const breakElement = document.createElement('break');
    breakElement.setAttribute(
      block.controls.break.type,
      block.controls.break.value
    );
    blockVoice.insertAdjacentElement('beforeend', breakElement);
  }

  return blockVoice;
};

export const generateSsml = (blocks: Block[]) => {
  const ssmlDoc = document.createElement('speak');
  ssmlDoc.setAttribute('xmlns', 'http://www.w3.org/2001/10/synthesis');
  ssmlDoc.setAttribute('xmlns:mstts', 'http://www.w3.org/2001/mstts');
  ssmlDoc.setAttribute('xmlns:emo', 'http://www.w3.org/2009/10/emotionml');
  ssmlDoc.setAttribute('version', '1.0');
  ssmlDoc.setAttribute('xml:lang', 'en-US');

  if (blocks.length === 1) {
    const blockSsml = generateBlockSsml(blocks[0]);
    ssmlDoc.appendChild(blockSsml);
    return ssmlDoc.outerHTML;
  }

  blocks.forEach((block) => {
    const blockSsml = generateBlockSsml(block);
    ssmlDoc.appendChild(blockSsml);
  });

  return ssmlDoc.outerHTML;
};

export const applySelections = (block: Block) => {
  let content = block.html;
  let addedChars = 0;

  // A lógica abaixo itera o array de selections, para cada selection,
  // verifica a existencia de um control de style, caso exista verifica
  // se é o único controle, se positivo, define a tag como um mstts:express-as
  // e seu valor apenas, caso possua style, mas não seja o único controlador
  // abre a tag com u mstts:express-as e um prosody, com seus respectivos
  // valores, porém caso não possua styles, abre a tag como um prosody e
  // seus valores apenas.

  block.selections
    .sort((a, b) => a.start - b.start)
    .forEach((selection) => {
      if (selection.controls.length > 0) {
        const hasStyle = selection.controls.find(
          (c) => c.control === 'style'
        )?.value;
        const hasSpeed = selection.controls.find(
          (c) => c.control === 'speed'
        )?.value;
        const hasPronunciation = selection.controls.find(
          (c) => c.control === 'pronunciation'
        )?.value as PronunciationEffect | undefined;

        const openTag =
          (hasStyle ? `<mstts:express-as style="${hasStyle}">` : '') +
          (hasSpeed ? `<prosody rate="${hasSpeed}">` : '') +
          (hasPronunciation
            ? hasPronunciation.type === 'interpret'
              ? `<say-as interpret-as="${hasPronunciation.value}">`
              : `<sub alias="${hasPronunciation.value}">`
            : '');

        const closeTag =
          (hasPronunciation
            ? hasPronunciation.type === 'interpret'
              ? '</say-as>'
              : '</sub>'
            : '') +
          (hasSpeed ? '</prosody>' : '') +
          (hasStyle ? '</mstts:express-as>' : '');

        const selectionContent = content.substring(
          selection.start + addedChars,
          selection.end + addedChars
        );

        content =
          content.substring(0, selection.start + addedChars) +
          openTag +
          selectionContent +
          closeTag +
          content.substring(selection.end + addedChars);

        addedChars += openTag.length + closeTag.length;
      }
    });

  return content;
};
